module.exports = __webpack_public_path__ + "img/No_Product@3x.1a8bff71.png";